import Reflux                 from 'reflux';
import $                      from 'jquery';
import screenfull             from 'screenfull';
import ControlsActionsFactory from './player-controls/controls-actions-factory';
import VideoActionsFactory    from './video-actions-factory';
import VideoEvents            from './video-events';
import AmpPlayerEvents        from './amp-player-events';
import Settings               from './configs/settings';
import Utils                  from 'medscape/utils';
import { throttle }           from 'lodash';

/*
    VideoStore
    Manages and delegates the events triggered by the media's <video> element object
    and the actions from the player's controls.
    Sets the state to the Akamai's AMP media config JSON object.
    Uses akamai's AMP media api to determine the what the player's controls state should be.
*/
class VideoStore extends Reflux.Store {
  constructor(config, route) {
    super();
    this.VideoActions = VideoActionsFactory.get(config["config-id"], route);
    this.ControlsActions = ControlsActionsFactory.get(config["config-id"], route);
    this.config = config;
    this.isVolumechange = false;
    this.listenables = [this.VideoActions, this.ControlsActions];
  }
  onInit() { }
  onDestroy() {
    let mediaElement = this.mediaApi.getMediaElement();
    let $mediaElement = $(mediaElement);
    $mediaElement.off('click.video');
    $mediaElement.off('tap.video');
    $(document).off(screenfull.raw.fullscreenchange);
    VideoEvents.forEach( (videoEvent) => {
      const videoEventName = videoEvent + '.VideoStore';
      $mediaElement.off(videoEventName).on(videoEventName, ()=> {
        this.VideoActions[videoEvent]();
      });
    });
    this.mediaApi.destroy();
  }
  onReady(mediaApi) {
      let mediaElement = mediaApi.getMediaElement();
      let $mediaElement = $(mediaElement);
      this.mediaApi = mediaApi;
      this.mediaElement = mediaElement;
      window.mediaApi = mediaApi;
      this.$mediaElement = $mediaElement;
      VideoEvents.forEach( (videoEvent) => {
        const videoEventName = videoEvent + '.VideoStore';
        $mediaElement.off(videoEventName).on(videoEventName, () => {
          this.VideoActions[videoEvent](mediaApi);
        });
      });
      if(!Utils.isMobile()) {
        AmpPlayerEvents.forEach( (playerEvent)=>{
          if(playerEvent === 'fullscreenchange' && Utils.isIEorEDGE() && !Utils.isEdge()) {
            if(!Utils.isMobile() && screenfull.raw.fullscreenchange) {
              $(document).on(screenfull.raw.fullscreenchange, (e) => {
                if(document.msFullscreenElement == null) {
                  this.VideoActions[playerEvent](mediaApi);
                  this.mediaApi.exitFullScreen();
                } else {
                  this.VideoActions[playerEvent](mediaApi);
                  this.mediaApi.enterFullScreen();
                }
              });
            }
          } else {
            this.mediaApi.addEventListener(playerEvent, () => {
              this.VideoActions[playerEvent](mediaApi);
            });
          }
        });
      }
      this.ControlsActions.show();
  }
  onSetMedia(video) {}
  /* Listeners for the Controls */
  onTogglePlayPause() {
    if(this.mediaElement.currentTime === 0 || this.mediaElement.paused) {
      this.mediaApi.play();
    } else {
      this.mediaApi.pause();
    }
  }
  onChangeCurrentTime(currentTime) {
    this.mediaElement.currentTime = currentTime;
    this.mediaApi.setCurrentTime(currentTime);
    this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
  }
  onChangeVolume(volume) {
    this.mediaApi.setVolume(volume);
  }
  onDestroy() {
    this.stopListeningToAll();
    this.mediaApi.destroy();
  }
  onEnded() {
    //this.ControlsActions.setPause(true);
    this.mediaApi.end();
    this.mediaApi.setCurrentTime(0);
  }
  onToggleMute() {
    let flag = !this.mediaApi.getMuted();
    this.mediaApi.setMuted(flag);
  }
  /* Listeners for the Video */
  onDurationchange() {
    this.ControlsActions.setDuration(this.mediaElement.duration);
  }
  onLoadeddata() {
    const data = {
      currentTime: this.mediaElement.currentTime,
      duration: this.mediaElement.duration,
      isReady: true
    };
    this.ControlsActions.init(data);
    this.ControlsActions.setPause(true);
  }
  onLoadedmetadata() {
    this.state.isEnded = false;
  }
  onPause() {
    this.ControlsActions.setPause(true);
  }
  onPlay() {
    this.ControlsActions.setPause(false);
  }
  onPlaying() {
    this.ControlsActions.setPause(false);
  }
  onSeeking() {
    this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
  }
  onToggleFullscreen() {
    if(this.mediaApi.displayState!="full-screen") {
      this.mediaApi.enterFullScreen();
    } else if(this.mediaApi.displayState=="full-screen")  {
      this.mediaApi.exitFullScreen();
    }
  }
  onVolumechange(){
    this.ControlsActions.setVolume(this.mediaApi.getVolume());
  }
  onMutechange() { }
  onTimeupdate() {
    if(this.mediaElement) {
      this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
    }
  }
}
let StoreCache = {};


VideoStore.get = function(config, route) {
  const key = `${route.location.pathname}${config["config-id"]}`;
  if(StoreCache[key]==null) {
    StoreCache[key] = new VideoStore(config, route);
    StoreCache[key].timeStamp = Date.now();
  }
  return StoreCache[key];
}
VideoStore.clearCache = function() {
  Object.keys(StoreCache).forEach((key)=> {
    VideoActionsFactory.clearCache();
    delete StoreCache[key];
  });
}


export default VideoStore;


// WEBPACK FOOTER //
// ./medscape_modules/video/video-store.js